module.exports = __webpack_public_path__ + "img/user_LiuBo.02b30f37.png";